// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"564":"5024ab01","616":"bb99cd9d","806":"f8d6f6bc","950":"39c9a4ce"}[chunkId] + ".chunk.css";
};